
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Project } from '@shared/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonModule } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { HintComponent } from '@shared-angular/components/hint/hint.component';
import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from 'src/app/shared/services/project.service';

@Component({
  selector: 'app-project-modal',
  imports: [FormsModule, HintComponent, InputText, TextareaModule, SelectModule, ButtonModule],
  templateUrl: './ProjectModal.component.html',
  styleUrl: './ProjectModal.component.css',
  standalone: true
})
export class ProjectModalComponent {
  public project: Project = {
    _id: '',
    name: '',
    orgShort: '',
    editMode: 'creator',
    creator: '',
    description: '',
    created: '',
    updated: ''
  };

  public editModeOptions = [
    {
      label: $localize`:@@only-creator:Ersteller`,
      value: 'creator'
    },
    {
      label: $localize`:@@everyone:Jedem in der Organisation`,
      value: 'everyone'
    },
    {
      label: $localize`:@@no-editing:Niemanden`,
      value: 'none'
    }
  ];

  public get orgShareOptions(): { label: string; value: string }[] {
    return [
      {
        label: $localize`:@@no-sharing:Nicht geteilt`,
        value: ''
      },
      ...this.loginService.myOrgs.map((model) => ({
        label: model.name,
        value: model.short
      }))
    ];
  }

  constructor(private bsModalRef: BsModalRef, private projectService: ProjectService, public loginService: LoginService) { }

  public async addProject() {
    this.project.name = this.project.name.trim();
    if (this.project.name != '') {
      await this.projectService.createProject(this.project);
      this.bsModalRef.hide();
    }
  }
}
